"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diacriticsTextMode = {
    "`": true,
    "'": true,
    "^": true,
    "~": true,
    "=": true,
    ".": true,
    '"': true,
    "H": true,
    "c": true,
    "k": true,
    "b": true,
    "d": true,
    "r": true,
    "u": true,
    "v": true,
};
exports.diacriticsMathMode = {
    "hat": true,
    "widehat": true,
    "check": true,
    "tilde": true,
    "widetilde": true,
    "acute": true,
    "grave": true,
    "dot": true,
    "ddot": true,
    "breve": true,
    "bar": true,
    "vec": true,
    "mathring": true,
};
//# sourceMappingURL=diacritic.js.map